import { prepareRuntime } from './appMount';
import { initOwnContainer } from './mfContainer';

async function boot() {
  // Hosts use ./AppMount and never run this file; only standalone needs its own MF container initialised first.
  await initOwnContainer();
  await prepareRuntime('boot');
  await import('./bootloader');
}

boot().catch((error) => {
  console.error('[order-shipment-management-ui] boot failed', error);
});
